// extracted by mini-css-extract-plugin
export default {"item":"fJ9jh","itemDragging":"FVfmi","text":"GfjwD"};